import { APP_MODULES } from 'constants/appModules';
import { ddxModules } from 'constants/ddxModule';
import { eddrModules } from 'constants/eddrModules';
import { energyEfficiencyTabs } from 'constants/energyEfficiencyModules';
import { globalBenchmarkModules } from 'constants/globalBenchmarkModules';
import { LESSONS_LEARNT_MODULES, lessonsLearntModules } from 'constants/lessonsLearntModule';
import { PATHS } from 'constants/paths';
import { planningPanelModules } from 'constants/planningPanelModules';
import { userAdminModules } from 'constants/userAdminModules';
import { isKeyInObject, ObjectKeys } from 'helpers/ts-helpers';

const ddxTabs = ddxModules.map(ddxModule => ({
  name: ddxModule,
  displayedName: `header.pages.${ddxModule}`,
  path: PATHS[ddxModule],
}));

const eddrTabs = eddrModules.map(eddrModule => ({
  name: eddrModule,
  displayedName: `header.pages.${eddrModule}`,
  path: PATHS[eddrModule],
}));

const globalBenchmarkTabs = globalBenchmarkModules.map(globalBenchmarkModule => ({
  name: globalBenchmarkModule,
  displayedName: `header.pages.${globalBenchmarkModule}`,
  path: PATHS[globalBenchmarkModule],
}));

const planningPanelTabs = planningPanelModules.map(planningPanelModule => ({
  name: planningPanelModule,
  displayedName: `header.pages.${planningPanelModule}`,
  path: PATHS[planningPanelModule],
}));

const lessonLearntTabs = lessonsLearntModules
  .filter(module => module !== LESSONS_LEARNT_MODULES.LESSONS_LEARNT_VIEW)
  .map(lessonLearntModule => ({
    name: lessonLearntModule,
    displayedName: `header.pages.${lessonLearntModule}`,
    path: PATHS[lessonLearntModule],
  }));

const userAdminTabs = userAdminModules.map(module => ({
  name: module,
  displayedName: `header.pages.${module}`,
  path: PATHS[module],
}));

export const modulesWithTabs = {
  [APP_MODULES.DDX_PO]: ddxTabs,
  [APP_MODULES.EDDR]: eddrTabs,
  [APP_MODULES.ENERGY_EFFICIENCY]: energyEfficiencyTabs,
  [APP_MODULES.GLOBAL_BENCHMARK]: globalBenchmarkTabs,
  [APP_MODULES.PLANNING_PANEL]: planningPanelTabs,
  [APP_MODULES.LESSONS_LEARNT]: lessonLearntTabs,
  [APP_MODULES.USER_ADMIN]: userAdminTabs,
} as const;

export const tabsModulesList = ObjectKeys(modulesWithTabs);

export type TAB_MODULES = (typeof tabsModulesList)[number];

export const getTabsByCurrentModule = (currentModule?: APP_MODULES) => {
  if (currentModule === undefined) {
    return undefined;
  }

  return isKeyInObject(currentModule, modulesWithTabs) ? modulesWithTabs[currentModule] : undefined;
};

export const formatWellName = (wellName: string | undefined) => {
  return wellName?.replaceAll(/[(|)]/g, '').split(' ').join('-');
};
